<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import logo2 from '../assets/logo2.jpg'

const router = useRouter()
const route = useRoute()

const isMobileMenuOpen = ref(false)
const isBusinessSubMenuOpen = ref(false)

const scrollToSection = (sectionId) => {
    if (route.path !== '/') {
        router.push('/').then(() => {
            setTimeout(() => {
                const element = document.getElementById(sectionId)
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
                }
            }, 300)
        })
    } else {
        const element = document.getElementById(sectionId)
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }
    closeMobileMenu()
}

const navigateToEmployment = () => {
    router.push('/employment')
    closeMobileMenu()
}

const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const closeMobileMenu = () => {
    isMobileMenuOpen.value = false
    isBusinessSubMenuOpen.value = false
}

// const toggleBusinessSubMenu = () => {
//     isBusinessSubMenuOpen.value = !isBusinessSubMenuOpen.value
// }
</script>

<template>
    <header class="header">
        <!-- PC表示のナビゲーション -->
        <nav class="desktop-nav">
            <ul class="nav-list">
                <li><a @click="scrollToSection('hero')" class="nav-link">ホーム</a></li>
                <!--<li class="nav-item-dropdown">
                    <a @click="scrollToSection('business-content')" class="nav-link">事業内容</a>
                    <ul class="dropdown-menu">
                        <li><a @click="scrollToSection('scaffold-assembly')" class="dropdown-link">足場の組み立て</a></li>
                    </ul>
                </li> -->
                <li><a @click="scrollToSection('business-content')" class="nav-link">事業内容</a></li>
                <li><a @click="scrollToSection('philosophy')" class="nav-link">経営理念</a></li>
                <li><a @click="navigateToEmployment" class="nav-link">採用情報</a></li>
                <li><a @click="scrollToSection('ceo-message')" class="nav-link">代表挨拶</a></li>
                <li><a @click="scrollToSection('company-overview')" class="nav-link">会社概要</a></li>
            </ul>
        </nav>

        <!-- スマホ表示のハンバーガーメニュー -->
        <div class="mobile-nav">
            <button @click="toggleMobileMenu" class="hamburger-btn">
                <span class="hamburger-line"></span>
                <span class="hamburger-line"></span>
                <span class="hamburger-line"></span>
            </button>
            <a href="https://lin.ee/X50R3qg" target="_blank" class="mobile-line-icon">
                LINE
            </a>
        </div>

        <!-- スマホメニューオーバーレイ -->
        <Transition name="mobile-menu">
            <div v-show="isMobileMenuOpen" class="mobile-menu-overlay" @click="closeMobileMenu">
                <div class="mobile-menu" @click.stop>
                <ul class="mobile-nav-list">
                    <li class="mobile-nav-header" @click="scrollToSection('hero')">
                        <img :src="logo2" alt="RSJ株式会社ロゴ" class="mobile-logo">
                        <span class="mobile-company-name">RSJ株式会社</span>
                        <span class="close-icon">×</span>
                    </li>
                    <li><a @click="scrollToSection('hero')" class="mobile-nav-link">ホーム</a></li>
                    <!--<li class="mobile-dropdown-item">
                        <a @click="toggleBusinessSubMenu" class="mobile-nav-link mobile-dropdown-trigger">
                            事業内容
                            <span class="dropdown-arrow" :class="{ 'open': isBusinessSubMenuOpen }">▼</span>
                        </a>
                        <ul v-show="isBusinessSubMenuOpen" class="mobile-submenu">
                            <li><a @click="scrollToSection('business-content')" class="mobile-submenu-link">事業内容概要</a></li>
                            <li><a @click="scrollToSection('scaffold-assembly')" class="mobile-submenu-link">足場の組み立て</a></li>
                        </ul>
                    </li> -->
                    <li><a @click="scrollToSection('business-content')" class="mobile-nav-link">事業内容</a></li>
                    <li><a @click="scrollToSection('philosophy')" class="mobile-nav-link">経営理念</a></li>
                    <li><a @click="navigateToEmployment" class="mobile-nav-link">採用情報</a></li>
                    <li><a @click="scrollToSection('ceo-message')" class="mobile-nav-link">代表挨拶</a></li>
                    <li><a @click="scrollToSection('company-overview')" class="mobile-nav-link">会社概要</a></li>
                </ul>
            </div>
        </div>
        </Transition>
    </header>
</template>

<style scoped>
.header {
    position: fixed;
    top: 0;
    width: 100%;
    background: rgba(18, 18, 18, 0.96);
    backdrop-filter: blur(10px);
    z-index: 1000;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    border-bottom: 1px solid rgba(255, 128, 48, 0.2);
}

/* PC表示のナビゲーション */
.desktop-nav {
    display: block;
    padding: 1rem 2rem;
}

.nav-list {
    display: flex;
    justify-content: center;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 2rem;
}

.nav-link {
    color: #e0e0e0;
    text-decoration: none;
    font-weight: 500;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.nav-link:hover {
    background-color: rgba(255, 128, 48, 0.15);
    color: #ff8030;
}

/* ドロップダウンメニュー */
.nav-item-dropdown {
    position: relative;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background: #1a1a1a;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0,0,0,0.5);
    list-style: none;
    margin: 0;
    padding: 0.5rem 0;
    min-width: 180px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.3s ease;
    z-index: 1100;
    border: 1px solid rgba(255,128,48,0.2);
}

.nav-item-dropdown:hover .dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.dropdown-link {
    display: block;
    color: #e0e0e0;
    text-decoration: none;
    padding: 0.7rem 1.2rem;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    cursor: pointer;
}

.dropdown-link:hover {
    background-color: rgba(255,128,48,0.15);
    color: #ff8030;
}

/* スマホ表示のハンバーガーメニュー */
.mobile-nav {
    display: none;
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1001;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
}

.hamburger-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
    border-radius: 5px;
    background-color: rgba(30, 30, 30, 0.95);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(255,128,48,0.3);
}

.hamburger-line {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #e0e0e0;
    margin: 5px 0;
    transition: 0.3s;
}

/* モバイルメニューオーバーレイ */
.mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1002;
    display: flex;
    justify-content: flex-end;
}

.mobile-menu {
    width: 100%;
    height: 100%;
    background-color: #000000;
    padding: 2rem;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.5);
}

.mobile-nav-list {
    list-style: none;
    padding: 0;
    margin: 0;
    padding-top: 2rem;
}

.mobile-nav-list li {
    margin-bottom: 1rem;
    border: 10px;
    border-color: rgba(255, 128, 48, 0.4);
    border-radius: 10px;
    border-style: inset;
    border-right: none;
    border-bottom: none;
}

.close-icon {
    font-size: 30px;
    margin-left: auto;
}


.mobile-nav-header {
    display: flex;
    align-items: center;
    padding: 1rem;
    margin-bottom: 2rem;
    border-bottom: 1px solid rgba(255,128,48,0.3);
}

.mobile-logo {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 8px;
    margin-right: 1rem;
}

.mobile-company-name {
    font-size: 1.3rem;
    font-weight: 600;
    color: #ffffff;
}

.mobile-nav-link {
    display: block;
    color: #e0e0e0;
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: 500;
    padding: 1rem;
    border-radius: 5px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.mobile-nav-link:hover {
    background-color: rgba(255,128,48,0.15);
    color: #ff8030;
}

/* モバイルメニューアニメーション */
.mobile-menu-enter-active,
.mobile-menu-leave-active {
    transition: all 0.5s ease-in-out;
}

.mobile-menu-enter-from {
    opacity: 0;
    transform: translateX(100%);
}

.mobile-menu-leave-to {
    opacity: 0;
    transform: translateX(100%);
}

.mobile-menu-enter-to,
.mobile-menu-leave-from {
    opacity: 1;
    transform: translateX(0);
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
    .desktop-nav {
        display: none;
    }

    .mobile-nav {
        display: flex;
    }

    .header {
        background: transparent;
        box-shadow: none;
    }

    /* モバイルサブメニュー */
    .mobile-dropdown-trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .dropdown-arrow {
        transition: transform 0.3s ease;
        font-size: 0.8rem;
    }

    .dropdown-arrow.open {
        transform: rotate(180deg);
    }

    .mobile-submenu {
        list-style: none;
        padding: 0;
        margin: 0.5rem 0 0 0;
        background-color: white;
        border-radius: 5px;
    }

    .mobile-submenu li{
        border: none;;
    }

    .mobile-submenu-link {
        display: block;
        color: #555;
        text-decoration: none;
        padding: 0.8rem 1.5rem;
        margin-left: 1rem;
        transition: all 0.3s ease;
        cursor: pointer;
        font-size: 1rem;
        border: 6px;
        border-color: rgba(255, 153, 0, 0.5);
        border-radius: 6px;
        border-style: inset;
        border-right: none;
        border-bottom: none;
    }

    .mobile-submenu-link:hover {
        background-color: #f0f0f0;
        color: #007bff;
    }

    .mobile-line-icon {
        background-color: #00B900;
        color: white;
        font-weight: 700;
        font-size: 12px;
        padding: 10px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 10px rgba(0, 185, 0, 0.3);
        transition: all 0.3s ease;
        text-decoration: none;
        width: 45px;
        height: 45px;
    }

    .mobile-line-icon:hover {
        background-color: #009900;
        transform: scale(1.1);
        box-shadow: 0 4px 12px rgba(0, 185, 0, 0.4);
    }
}
</style>